export const translations = {
  no: {
    // Navigation
    home: 'Hjem',
    shop: 'Butikk',
    about: 'Om oss',
    contact: 'Kontakt',
    cart: 'Handlekurv',
    login: 'Logg inn',
    register: 'Registrer',
    logout: 'Logg ut',
    account: 'Konto',
    
    // Hero
    heroTagline: 'Kåret til verdens beste foundation',
    heroSubtitle: '100% ren mineralmakeup fra Norge',
    shopNow: 'Handle nå',
    learnMore: 'Les mer',
    
    // Products
    products: 'Produkter',
    allProducts: 'Alle produkter',
    featured: 'Utvalgte',
    foundation: 'Foundation',
    blush: 'Rouge',
    eyeshadow: 'Øyenskygge',
    lipstick: 'Leppestift',
    mascara: 'Maskara',
    brushes: 'Pensler',
    addToCart: 'Legg i handlekurv',
    outOfStock: 'Utsolgt',
    selectShade: 'Velg nyanse',
    price: 'Pris',
    
    // Cart
    yourCart: 'Din handlekurv',
    emptyCart: 'Handlekurven er tom',
    continueShopping: 'Fortsett å handle',
    checkout: 'Gå til kassen',
    subtotal: 'Delsum',
    total: 'Totalt',
    remove: 'Fjern',
    quantity: 'Antall',
    
    // Auth
    emailAddress: 'E-postadresse',
    password: 'Passord',
    firstName: 'Fornavn',
    lastName: 'Etternavn',
    signIn: 'Logg inn',
    signUp: 'Registrer deg',
    alreadyHaveAccount: 'Har du allerede en konto?',
    dontHaveAccount: 'Har du ikke en konto?',
    
    // Contact
    contactUs: 'Kontakt oss',
    yourName: 'Ditt navn',
    yourEmail: 'Din e-post',
    yourMessage: 'Din melding',
    sendMessage: 'Send melding',
    
    // Newsletter
    subscribeNewsletter: 'Abonner på nyhetsbrev',
    enterEmail: 'Skriv inn e-post',
    subscribe: 'Abonner',
    
    // About
    aboutUs: 'Om oss',
    ourStory: 'Vår historie',
    naturalBeauty: 'Naturlig skjønnhet',
    
    // Footer
    followUs: 'Følg oss',
    customerService: 'Kundeservice',
    privacyPolicy: 'Personvernerklæring',
    termsConditions: 'Vilkår og betingelser',
    
    // Messages
    addedToCart: 'Lagt til i handlekurv',
    removedFromCart: 'Fjernet fra handlekurv',
    orderPlaced: 'Ordre plassert',
    paymentSuccessful: 'Betaling vellykket',
    messageSent: 'Melding sendt',
    subscribed: 'Abonnert',
  },
  en: {
    // Navigation
    home: 'Home',
    shop: 'Shop',
    about: 'About',
    contact: 'Contact',
    cart: 'Cart',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    account: 'Account',
    
    // Hero
    heroTagline: 'Awarded World\'s Best Foundation',
    heroSubtitle: '100% Pure Mineral Makeup from Norway',
    shopNow: 'Shop Now',
    learnMore: 'Learn More',
    
    // Products
    products: 'Products',
    allProducts: 'All Products',
    featured: 'Featured',
    foundation: 'Foundation',
    blush: 'Blush',
    eyeshadow: 'Eyeshadow',
    lipstick: 'Lipstick',
    mascara: 'Mascara',
    brushes: 'Brushes',
    addToCart: 'Add to Cart',
    outOfStock: 'Out of Stock',
    selectShade: 'Select Shade',
    price: 'Price',
    
    // Cart
    yourCart: 'Your Cart',
    emptyCart: 'Your cart is empty',
    continueShopping: 'Continue Shopping',
    checkout: 'Checkout',
    subtotal: 'Subtotal',
    total: 'Total',
    remove: 'Remove',
    quantity: 'Quantity',
    
    // Auth
    emailAddress: 'Email Address',
    password: 'Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: 'Don\'t have an account?',
    
    // Contact
    contactUs: 'Contact Us',
    yourName: 'Your Name',
    yourEmail: 'Your Email',
    yourMessage: 'Your Message',
    sendMessage: 'Send Message',
    
    // Newsletter
    subscribeNewsletter: 'Subscribe to Newsletter',
    enterEmail: 'Enter your email',
    subscribe: 'Subscribe',
    
    // About
    aboutUs: 'About Us',
    ourStory: 'Our Story',
    naturalBeauty: 'Natural Beauty',
    
    // Footer
    followUs: 'Follow Us',
    customerService: 'Customer Service',
    privacyPolicy: 'Privacy Policy',
    termsConditions: 'Terms & Conditions',
    
    // Messages
    addedToCart: 'Added to cart',
    removedFromCart: 'Removed from cart',
    orderPlaced: 'Order placed',
    paymentSuccessful: 'Payment successful',
    messageSent: 'Message sent',
    subscribed: 'Subscribed',
  }
};